import React, { useState, useEffect } from 'react';
import GetRequest from '../Services/APIRequest';
import Loading from '../Components/Loading';
import Error from '../Components/Error';

const ProductNeverOrder = () => {
    const distID = localStorage.getItem('distributorId');
    const { data, error, isLoaded } = GetRequest(`/Product/GetProductsNotOrdered/${distID}`);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [activeFilter, setActiveFilter] = useState("all");
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        if (data?.result) {
            const uniqueCategories = [
                ...new Set(data.result.map((item) => item.categoryName))
            ];
            setCategories(uniqueCategories);
            setFilteredProducts(data.result);
        }
    }, [data]);

    useEffect(() => {
        if (data?.result) {
            let filtered = data.result;
            if (activeFilter !== "all") {
                filtered = filtered.filter((item) => item.categoryName === activeFilter);
            }
            if (searchTerm) {
                filtered = filtered.filter((item) =>
                    item.name.toLowerCase().includes(searchTerm.toLowerCase())
                );
            }
            setFilteredProducts(filtered);
        }
    }, [activeFilter, searchTerm, data]);

    if (error !== null) {
        return <Error data="Product List" />;
    }
    if (!isLoaded) {
        return <Loading />;
    }

    return (
        <section className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card noUI">
                            <div className="card-header">
                                <button
                                    className={`form-control flBtn ${activeFilter === "all" ? "active" : ""}`}
                                    onClick={() => setActiveFilter("all")}
                                >
                                    All
                                </button>
                                {categories.map((category) => (
                                    <button
                                        key={category}
                                        className={`form-control flBtn ${activeFilter === category ? "active" : ""}`}
                                        onClick={() => setActiveFilter(category)}
                                    >
                                        {category}
                                    </button>
                                ))}
                                <div className="dropdown NOfilter">
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Search Product.."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="card-body">
                                <div id="accordion" className='row'>
                                    {filteredProducts.map((items) => (
                                        <div key={items.id} className="col-12 col-sm-6 col-md-4 itemfiltered">
                                            <div className="card">
                                                <div className="card-header">
                                                    <div className="row">
                                                        <div className="col-sm-12 centerImage">
                                                            {items.productSmallImage ? (
                                                                <img className="ProductsInfoHeadImg fade-in" src={items.productSmallImage} alt="Product" />
                                                            ) : (
                                                                <i className="fa fa-file-image-o dumProdBigIcon"></i>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-12 bgHeadPI" data-bs-toggle="collapse" href={`#collapse${items.id}`}>
                                                            <label className="prHeadName">
                                                                {items.name}
                                                                <span className="never-ordered-badge">Never Ordered</span>
                                                            </label>
                                                            <a className="btn dp-right-mt5">
                                                                <i className="fa fa-angle-double-down"></i>
                                                                <i className="fa fa-angle-double-up"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div id={`collapse${items.id}`} className="collapse" data-bs-parent="#accordion">
                                                    <div className="card-body">
                                                        {items.punchLine1 && (
                                                            <p className="text-center">
                                                                <button type="button" className="btn btn-outline-primary btn-block">
                                                                    {items.punchLine1}
                                                                </button>
                                                            </p>
                                                        )}

                                                        {/* Never Ordered Message with Bounce Effect */}
                                                        <p className="never-ordered bounce">
                                                            🚨 <b>Never Ordered</b> 🚨
                                                        </p>

                                                        {items.technicalName && <p>Technical Name: {items.technicalName}</p>}
                                                        {items.dosageInformation && <p>Dosage: <b>{items.dosageInformation}</b></p>}
                                                        {items.diseaseOrPestsCovered && <p>Coverage: <b>{items.diseaseOrPestsCovered}</b></p>}
                                                        {items.cropsRecommendedOn && <p>Crops: <b>{items.cropsRecommendedOn}</b></p>}
                                                        {items.description && <p>Details: <b>{items.description}</b></p>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProductNeverOrder;
